import type * as FindACourseModule from '../types/FindACourseModule'

export default function findACourseModuleComponentParser(
  rawComponent: FindACourseModule.Raw,
): FindACourseModule.Parsed {
  const { headers, filters, data } = rawComponent.findACourseModule
  const { titleText, countryText, dateText, locationText, timeText } = headers
  const { learnMoreText, noResultsFoundText } = data
  const filterKeys = ['course', 'country', 'stateProvince', 'language'] as const

  return {
    name: 'FindACourseModule',
    props: {
      titleText,
      countryText,
      dateText,
      locationText,
      timeText,
      learnMoreText,
      noResultsFoundText,
      courseMetaData: filters.course.courseDropdownOptions.reduce(
        (acc: FindACourseModule.CourseMetaData, option) => {
          acc[option.badge] = {
            title: option.captionCard.captionTitle,
            overviewUrl: option.link.url,
          }

          return acc
        },
        {},
      ),
      filters: filterKeys
        .map((field) => {
          const filter = filters[field]

          if (!filter) {
            return
          }

          const { labelText, placeholderText } = filter

          switch (field) {
            case 'stateProvince':
            case 'country':
              return {
                field,
                labelText,
                placeholderText,
              }
            case 'course':
              return {
                field,
                labelText,
                placeholderText,
                options: filters[field].courseDropdownOptions.map((option) => ({
                  label: option.captionCard.captionTitle,
                  value: option.badge,
                })),
              }
            case 'language': {
              const { languageDropdownOptions } = filters[field]
              return {
                field,
                labelText,
                placeholderText,
                options: languageDropdownOptions,
              }
            }
          }
        })
        .filter(Boolean),
    },
  }
}
